import React from 'react';

const CertificateCanvas = ({ userData, assessmentData, susanLogo, onRenderComplete }) => {
  const userName = userData?.name || userData?.['cognito:username'] || 'Participant';
  const percentage = assessmentData?.percentage || 0;
  
  const currentDate = new Date().toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "long",
    year: "numeric",
  });
  
  const certificateId = `DPDP-${Date.now()}-${Math.random().toString(36).substr(2, 6).toUpperCase()}`;

  React.useEffect(() => {
    if (onRenderComplete) {
      // Small delay to ensure render is complete
      setTimeout(() => {
        onRenderComplete();
      }, 100);
    }
  }, [onRenderComplete]);

  return (
    <div 
      id="certificate-canvas" 
      style={{
        width: '1754px',
        height: '1240px',
        position: 'absolute',
        left: '-9999px',
        marginTop: "40px",
        background: '#f8fcf8',
        padding: '80px',
        fontFamily: 'Arial, sans-serif'
      }}
    >
      {/* Border */}
      <div style={{
        width: '100%',
        height: '100%',
        border: '12px solid #061c31',
        borderRadius: '8px',
        padding: '15px',
        position: 'relative',
        boxSizing: 'border-box'
      }}>
        {/* Inner Border */}
        <div style={{
          width: '100%',
          height: '100%',
          border: '3px solid #061c31',
          borderRadius: '4px',
          padding: '60px 20px 20px 20px',
          boxSizing: 'border-box',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}>
          
          {/* Logo */}
          <div style={{ textAlign: 'center', marginBottom: '20px' }}>
            {susanLogo ? (
              <img src={susanLogo} alt="SUSAN Logo" style={{ height: '145px' }} />
            ) : (
              <h2 style={{ margin: 0, fontSize: '32px', color: '#061c31', fontWeight: 'bold' }}>
                SUSAN PORTAL
              </h2>
            )}
          </div>

          {/* Title */}
          <div style={{ textAlign: 'center', marginBottom: '40px' }}>
            <h1 style={{
              fontSize: '65px',
              fontWeight: 'bold',
              color: '#061c31',
              margin: '0 0 20px 0',
              letterSpacing: '2px'
            }}>
              ServQual Certified DPDPA Fundamentals
            </h1>
            <p style={{ fontSize: '32px', fontStyle: 'italic', margin: 0, color: '#000' }}>
              This certifies that
            </p> 
          </div>

          {/* Name */}
          <div style={{ textAlign: 'center', marginBottom: '40px' }}>
            <h2 style={{
              fontSize: '64px',
              fontWeight: 'bold',
              color: '#061c31',
              margin: '0 0 10px 0',
              textTransform: 'uppercase',
              borderBottom: '4px solid #061c31',
              paddingBottom: '10px',
              display: 'inline-block'
            }}>
              {userName}
            </h2>
          </div>

          {/* Achievement */}
          <div style={{ textAlign: 'center', marginBottom: '30px', maxWidth: '1200px' }}>
            <p style={{ fontSize: '22px', margin: '0 0 15px 0', color: '#000' }}>
              Has successfully completed the Certificate Course and Examination on the
            </p>
            <h3 style={{
              fontSize: '34px',
              fontWeight: 'bold',
              color: '#061c31',
              margin: '0 0 15px 0'
            }}>
              Digital Personal Data Protection Act, 2023,
            </h3>
            <p style={{ fontSize: '20px', margin: 0, color: '#000' }}>
             demonstrating strong knowledge of data protection and compliance requirements.
            </p>
          </div>

          {/* Percentage */}
          <div style={{ textAlign: 'center', marginBottom: '40px' }}>
            <p style={{ fontSize: '26px', fontWeight: 'bold', margin: 0, color: '#000' }}>
              Percentage Scored: {percentage}%
            </p>
          </div>

          {/* Footer */}
          <div style={{
            width: '100%',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-end',
            marginTop: 'auto'
          }}>
            <div style={{ textAlign: 'left', marginBottom:"50px" , marginLeft:"40px" }}>
              <p style={{ fontSize: '18px', fontStyle: 'normal', margin: 0, color: '#000' }}>
                Date of Issue: {currentDate}
              </p>
            </div>
            <div   style={{
    position: "absolute",
    bottom: "30px",     
    left: 0,
    right: 0,
    textAlign: "center",
  }}>
              <p style={{ fontSize: '14px', margin: '0 0 5px 0', color: '#505050', fontFamily: 'monospace'  }}>
                Certificate ID: {certificateId}
              </p>
              <p style={{ fontSize: '16px', fontWeight: 'bold', margin: 0, color: '#061c31' }}>
                This certificate is digitally generated. No Signature Required Passing Percentage is 75%.
              </p>
              
            </div>
            <div style={{ textAlign: 'right' }}>
              <p style={{ fontSize: '18px', margin: 40 , color: '#000' }}>
                https://srql.com
              </p>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default CertificateCanvas;
